import THistoryDetail from './index.vue';

THistoryDetail.install = app => {
  app.component(THistoryDetail.name, THistoryDetail);
};

export default THistoryDetail;
